import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { SprayProductUnits } from 'services/sprayEvents/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { UnitTypeName } from 'services/unitTypes/types';
import {
    makeSelectProductRatePerArea,
    makeSelectProductUnitType
} from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: ProductId;
}

interface ConnectedProps {
    productRatePerArea: SprayProductUnits;
    productUnitType: UnitTypeName;
}

type Props = OwnProps & ConnectedProps;

export class ProductRatePerAreaTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productRatePerArea, productUnitType } = this.props;

        return (
            <TableCell>
                {productRatePerArea}
                {productUnitType}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productRatePerArea: makeSelectProductRatePerArea(),
    productUnitType: makeSelectProductUnitType()
});

export default connect(mapStateToProps)(ProductRatePerAreaTableCellComponent);
